<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer047">
<p class="CN ParaOverride-1" id="_idParaDest-2" xml:lang="en-GB"><span class="CharOverride-1">Also by Mark Bowden</span></p>
<p class="BT-1st ParaOverride-2"><span class="CharOverride-2">Doctor Dealer</span></p>
<p class="BT-1st ParaOverride-2"><span class="CharOverride-2">Bringing the Heat</span></p>
<p class="BT-1st ParaOverride-2"><span class="CharOverride-2">Black Hawk Down</span></p>
<p class="BT-1st ParaOverride-2"><span class="CharOverride-2">Killing Pablo</span></p>
<p class="BT-1st ParaOverride-2"><span class="CharOverride-2">Finders Keepers</span></p>
<p class="BT-1st ParaOverride-2"><span class="CharOverride-2">Road Work</span></p>
<p class="BT-1st ParaOverride-2"><span class="CharOverride-2">Guests of the Ayatollah</span></p>
<p class="BT-1st ParaOverride-2"><span class="CharOverride-2">The Best Game Ever</span></p>
<p class="BT-1st ParaOverride-2"><span class="CharOverride-2">Worm</span></p>
<p class="BT-1st ParaOverride-2"><span class="CharOverride-2">The Finish</span></p>
<p class="BT-1st ParaOverride-2"><span class="CharOverride-2">The Three Battles of Wanat</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBook_V45571.vue?8e8c58cc